import * as React from "react";
import type { SVGProps } from "react";
const SvgIconVerified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M7.62 1.36c.2-.21.55-.21.76 0l.87.9q.23.23.53.15l1.2-.35c.3-.08.6.1.67.38l.3 1.22q.09.3.39.39l1.22.3c.29.07.46.37.38.66l-.35 1.2q-.07.31.14.54l.9.87c.22.2.22.55 0 .76l-.9.87q-.22.23-.14.53l.35 1.2c.08.3-.1.6-.38.67l-1.22.3q-.3.09-.39.39l-.3 1.22c-.07.29-.37.46-.66.38l-1.2-.35q-.32-.07-.54.14l-.87.9c-.2.22-.55.22-.76 0l-.87-.9q-.23-.22-.53-.14l-1.2.35c-.3.08-.6-.1-.67-.38l-.3-1.22q-.09-.3-.39-.39l-1.22-.3c-.29-.07-.46-.37-.38-.66l.35-1.2q.07-.31-.14-.54l-.9-.87c-.22-.2-.22-.55 0-.76l.9-.87q.22-.23.14-.53l-.35-1.2c-.08-.3.1-.6.38-.67l1.22-.3q.3-.09.39-.39l.3-1.22c.07-.29.37-.46.66-.38l1.2.35q.32.07.54-.14z"
      fill="#ECF1FF"
    />
    <path
      d="M7.62 1.36c.2-.21.55-.21.76 0l.87.9q.23.23.53.15l1.2-.35c.3-.08.6.1.67.38l.3 1.22q.09.3.39.39l1.22.3c.29.07.46.37.38.66l-.35 1.2q-.07.31.14.54l.9.87c.22.2.22.55 0 .76l-.9.87q-.22.23-.14.53l.35 1.2c.08.3-.1.6-.38.67l-1.22.3q-.3.09-.39.39l-.3 1.22c-.07.29-.37.46-.66.38l-1.2-.35q-.32-.07-.54.14l-.87.9c-.2.22-.55.22-.76 0l-.87-.9q-.23-.22-.53-.14l-1.2.35c-.3.08-.6-.1-.67-.38l-.3-1.22q-.09-.3-.39-.39l-1.22-.3c-.29-.07-.46-.37-.38-.66l.35-1.2q.07-.31-.14-.54l-.9-.87c-.22-.2-.22-.55 0-.76l.9-.87q.22-.23.14-.53l-.35-1.2c-.08-.3.1-.6.38-.67l1.22-.3q.3-.09.39-.39l.3-1.22c.07-.29.37-.46.66-.38l1.2.35q.32.07.54-.14z"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m10.62 6.01-3.6 4.51L5.2 9.17"
      stroke="#5C5CFF"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconVerified;
